var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgFrame(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.7,
    clipPath: "url(#clip0_25_2011)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.5556 19.9995H4.44444C1.98889 19.9995 0 18.0106 0 15.5551V4.44396C0 1.9884 1.98889 -0.000488281 4.44444 -0.000488281H15.5556C18.0111 -0.000488281 20 1.9884 20 4.44396V15.5551C20 18.0106 18.0111 19.9995 15.5556 19.9995Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 9.4231,
    y: 5.38464,
    width: 1.15385,
    height: 9.23077,
    rx: 0.576923,
    fill: "#0C0B0B"
  }), /*#__PURE__*/React.createElement("rect", {
    x: 14.6154,
    y: 9.4231,
    width: 1.15385,
    height: 9.23077,
    rx: 0.576923,
    transform: "rotate(90 14.6154 9.4231)",
    fill: "#0C0B0B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_25_2011"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFrame);
export default __webpack_public_path__ + "static/media/Frame.9187ae0f2bde0b32d94a7af5bcff2aef.svg";
export { ForwardRef as ReactComponent };